import { render, staticRenderFns } from "./ProjectPost.vue?vue&type=template&id=80e895a4&scoped=true&"
import script from "./ProjectPost.vue?vue&type=script&lang=js&"
export * from "./ProjectPost.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPost.vue?vue&type=style&index=0&id=80e895a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e895a4",
  null
  
)

export default component.exports